module.exports = __webpack_public_path__ + "img/logo-all-dark.ab09b72e.png";